<template>
  <div class="hv-carousel">
    <div class="d-flex flex-wrap justify-content-center" >
      <div v-for="(imageData, index) in imageUrlsData" :key="index" style="max-width: 200px;">
        <a :href="imageData.brandLinkCategory">
          <lazy-img picture-class="img-fluid item" :image-url="imageData.customImagePath" >
          </lazy-img>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "heista-image-carousel",
    jsonDataFields: [
      "imageUrlsData"
    ]
}
</script>